var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"collections"},[_c('div',{staticClass:"links"},_vm._l((_vm.collections),function(collection){return _c('router-link',{key:collection.uid,staticClass:"lundi",attrs:{"to":{ name: 'collection', params: { collection: _vm.$route.params.collection, id: collection.uid } }}},[_vm._v(_vm._s(collection.title))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }